import { render, staticRenderFns } from "./InfoSite.vue?vue&type=template&id=30d396fc&scoped=true&"
import script from "./InfoSite.vue?vue&type=script&lang=js&"
export * from "./InfoSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d396fc",
  null
  
)

export default component.exports